import { Fragment, h } from "preact";
import { Link } from "preact-router";
import * as styles from "./RKMenu.module.css";
import { getRoutesByLocale } from "../../core/Pages";
import useLocale from "../../hooks/useLocale";
import useCurrentRoute from "../../hooks/useCurrentRoute";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useEffect } from "preact/hooks";

const logoUrl = new URL("../../assets/images/r_k.jpeg", import.meta.url).href;


interface MenuItem {
  href: string;
  label: string;
  position: "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
}

interface RKMenuProps {
  items?: MenuItem[];
}

const RKMenu = ({ items }: RKMenuProps) => {
  const locale = useLocale();
  const currentRoute = useCurrentRoute();
  const routes = getRoutesByLocale(locale);
  const isTablet = useMediaQuery("(min-width: 600px)");

  const defaultItems: MenuItem[] = [
    { href: routes.ABOUT, label: "About ", position: "topRight" },
    { href: routes.CHAPTERS, label: "Chapters", position: "bottomLeft" },
    { href: routes.ARTISTS, label: "Artists", position: "topLeft" },
  ];

  const menuItems = items || defaultItems;

  useEffect(() => {
    console.log(isTablet)
  }, [isTablet])

  return (
    <div className={styles.rkMenu}>
      <Link href={routes.HOME}>
        <img className={styles.logo} src={logoUrl} />
      </Link>
      {isTablet ? (
        <Fragment>


          <nav className={styles.nav}>
            {menuItems.map((item, index) => {
              const isActive = currentRoute === item.href;

              return (
                <div key={item.position}>
                  <Link
                    href={item.href}
                    className={`${styles.menuItem} ${styles[item.position]} ${isActive ? styles.active : ""
                      } ${index === 0 ? "artists" : ""}`}
                  >
                    {item.label}
                  </Link>
                </div>
              );
            })}
          </nav>
        </Fragment>
      ) : (
        <Fragment>

          <BurgerMenu />
        </Fragment>
      )}
    </div>
  );
};

export default RKMenu;
